export default [{"url":"https://test-0.api.invexerp.io","name":"aba","port":"5050","isStore":true,"isHQ":true}]